import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TablePagination,
    Box,
    Typography,
    Stack
} from "@mui/material";
import { useState } from "react";
import { useQuery } from "react-query";
import axiosClient from "../../../../../../../lib/axios";
import { IDataRefUltimasCompras } from "../../../../../../../types/api/estoque/detalhar-referencia-ultimas-compras";
import SelectLoja from "../../../../../../../components/SelectsSimpleApiQuery/SelectLoja";
import { IDataLojas } from "../../../../../../../types/api/geral/pesquisar-lojas";
import TableSkeleton from "../../../../../../../components/BasicComponents/Skeletons/TableSkeleton";
import moment from "moment";

export default function DialogUltimasCompras({
    open,
    onClose,
    produtoId
}: IDialogUltimasComprasProps) {

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [lojaFiltro, setLojaFiltro] = useState<IDataLojas | null>(null);

    const { data, isLoading } = useQuery({
        queryKey: ['ultimas-compras', produtoId, page, rowsPerPage, lojaFiltro],
        queryFn: () => axiosClient.get(`/estoque/detalhar-referencia-ultimas-compras`, {
            params: {
                produto_id: produtoId,
                page: page + 1,
                per_page: rowsPerPage,
                ...(lojaFiltro && { loja_id: lojaFiltro })
            }
        }),
        cacheTime: 0,
        enabled: open
    })

    const ultimasCompras: IDataRefUltimasCompras[] = data?.data.data || []
    const totalCompras = data?.data.total || 0
    const carregando = isLoading || !data

    const handleChangePage = (_: unknown, newPage: number) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleLojaFiltroChange = (loja: IDataLojas | null) => {
        setLojaFiltro(loja);
        setPage(0);
    };

    return (
        <Dialog
            fullWidth
            maxWidth="lg"
            open={open}
        >
            <DialogTitle>
                <Stack direction="row" justifyContent="space-between" alignItems="center">
                    <Typography variant="h6">Últimas compras</Typography>
                    <SelectLoja
                        value={lojaFiltro}
                        onChange={handleLojaFiltroChange}
                        fullWidth={false}
                        size="small"
                        possuiBtnLimpar
                    />
                </Stack>
            </DialogTitle>

            <DialogContent>
                {
                    carregando && (
                        <Box p={2}>
                            <TableSkeleton rows={10} columns={5} />
                        </Box>
                    )
                }
                {
                    !carregando && (
                        <>
                            <TableContainer sx={{ border: '1px solid #e0e0e0', borderRadius: 1 }}>
                                <Table size="small">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell><b>Data</b></TableCell>
                                            <TableCell><b>Loja</b></TableCell>
                                            <TableCell><b>Num. ordem compra</b></TableCell>
                                            <TableCell><b>Nota fiscal</b></TableCell>
                                            <TableCell><b>Emissão</b></TableCell>
                                            <TableCell><b>Fornecedor</b></TableCell>
                                            <TableCell align="right"><b>Quantidade</b></TableCell>
                                            <TableCell align="right"><b>Valor Unit.</b></TableCell>
                                            <TableCell align="right"><b>Total</b></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {ultimasCompras.map((compra, index) => (
                                            <TableRow key={index} hover>
                                                <TableCell>
                                                    {moment(compra.data_movimento).format('DD/MM/YYYY')}
                                                </TableCell>
                                                <TableCell>{compra.nome_loja}</TableCell>
                                                <TableCell>{compra.numero_ordem_de_compra}</TableCell>
                                                <TableCell>{compra.numero_documento}</TableCell>
                                                <TableCell>{moment(compra.data_atualizacao).format('DD/MM/YYYY')}</TableCell>
                                                <TableCell>{`${compra.fornecedor_id ? `${compra.fornecedor_id} - ` : ''}${compra.nome_fornecedor ?? '-'}`}</TableCell>
                                                <TableCell align="right">
                                                    {compra.quantidade_comprada.toLocaleString('pt-BR')}
                                                </TableCell>
                                                <TableCell align="right">
                                                    {compra.valor_unitario.toLocaleString('pt-BR', {
                                                        style: 'currency',
                                                        currency: 'BRL'
                                                    })}
                                                </TableCell>
                                                <TableCell align="right">
                                                    <Typography variant="subtitle2">
                                                        {(compra.quantidade_comprada * compra.valor_unitario).toLocaleString('pt-BR', {
                                                            style: 'currency',
                                                            currency: 'BRL'
                                                        })}
                                                    </Typography>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>

                            <TablePagination
                                component="div"
                                count={totalCompras}
                                page={page}
                                onPageChange={handleChangePage}
                                rowsPerPage={rowsPerPage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                                rowsPerPageOptions={[5, 10, 25, 50]}
                                labelRowsPerPage="Linhas por página:"
                                labelDisplayedRows={({ from, to, count }) =>
                                    `${from}-${to} de ${count !== -1 ? count : `mais de ${to}`}`
                                }
                            />
                        </>
                    )}
            </DialogContent>

            <DialogActions>
                <Button
                    variant="outlined"
                    color="primary"
                    onClick={onClose}
                >
                    Fechar
                </Button>
            </DialogActions>
        </Dialog>
    )
}

interface IDialogUltimasComprasProps {
    open: boolean;
    onClose: () => void;
    produtoId: number;
}
